import { render } from "./SocialItem.vue?vue&type=template&id=4f6f1616&scoped=true"
import script from "./SocialItem.vue?vue&type=script&lang=js"
export * from "./SocialItem.vue?vue&type=script&lang=js"

import "./SocialItem.vue?vue&type=style&index=0&id=4f6f1616&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6f1616"]])

export default __exports__